import React from 'react';

import { Box, Grid, Link } from '@mui/material';

// import newLogo from "./img/ResMed_MaskSelector_logo.svg"

import BackArrow from 'ui_patient/pages/MaskSelectorTool/img/BackArrow';

import PropTypes from 'prop-types';

import MaskSelectorToolStyles from 'ui_patient/pages/MaskSelectorTool/MaskSelectorToolStyles';
import { useTranslation } from 'react-i18next';

import { nextGenExpandHeightTransition } from 'ui_patient/pages/MaskSelectorTool/AnimationConfig';

export const defaultHeaderLinkColor = '#FFFFFF';
export const defaultHeaderBackgroundColor = '#006DB7';

const Header = ({
  displayBackButton,
  handleBackLink,
  handleHelpLink,
  displayHelpButton = false,
  expanded = false,
  displayLogo = true,
  background = defaultHeaderBackgroundColor,
  linkColor = defaultHeaderLinkColor,
  handleReturnToHome
}) => {
  const { classes } = MaskSelectorToolStyles();
  const { t } = useTranslation('pages.MaskSelectorTool.Header');

  // Localization Strings
  const backLink = t('backLink');
  const helpLink = t('helpLink');

  const linkStyle = {
    color: linkColor,
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'none',
    },
    fontSize: '16px',
    fontWeight: '700',
  };

  const boxStyles = {
    backgroundColor: background,
    backgroundSize: '100% 200%',
    transition: expanded ? nextGenExpandHeightTransition : '',
    height: expanded ? 0 : 53,
  };

  return (
    <>
      <Box style={boxStyles} className={classes.headerFooterContainer}>
        <Box
          justifyContent="center"
          display="flex"
          className={classes.headerContent}
        >
          <Grid container>
            <Grid item xs={3} className={classes.headerLeft}>
              {displayBackButton && (
                <Link
                  href="#"
                  onClick={handleBackLink}
                  className={classes.header_back_link}
                  data-testid="header-back-button"
                >
                  <Box display="flex" style={{ marginTop: '-1.5px' }}>
                    <Box className={classes.header_back_arrowBox}>
                      <BackArrow
                        strokeColor={linkColor}
                        height="13px"
                        width="6.8px"
                      />
                    </Box>
                    <Box style={linkStyle}>{backLink}</Box>
                  </Box>
                </Link>
              )}
            </Grid>

            <Grid item xs={6} className={classes.headerCenter}>
              {displayLogo && (
                <span style={{ color: 'white' }} onClick={handleReturnToHome}>
                  ResMed <b>SelfieCollect</b>
                </span>
                // <img src={newLogo} alt="ResMed MaskSelector" data-testid="survey-logo"/>
              )}
            </Grid>

            <Grid item xs={3} className={classes.headerRight}>
              {displayHelpButton && (
                <Link
                  href="#"
                  style={linkStyle}
                  className={classes.header_back_link}
                  data-testid="header-help-button"
                  onClick={handleHelpLink}
                >
                  {helpLink}
                </Link>
              )}
            </Grid>
          </Grid>
        </Box>
      </Box>
    </>
  );
};

Header.propTypes = {
  displayBackButton: PropTypes.bool.isRequired,
  handleBackLink: PropTypes.func,
  handleHelpLink: PropTypes.func,
  handleReturnToHome: PropTypes.func,
  displayHelpButton: PropTypes.bool,
  expanded: PropTypes.bool,
  displayLogo: PropTypes.bool,
  background: PropTypes.string,
  linkColor: PropTypes.string,
};

export default Header;
